export class InternalOrderDetailModel {
  internalOrderDetailId: number = 0;
  internalOrderId: number = 0;
  articleId: number = 0;
  quantity: number = 0.0;
  totalAmountDeliveredQuantity: number = 0.0;
  totalPurchaseOrderQuantity: number = 0.0;
  pendingQuantity: number = 0.0;
  swUrgent: boolean = false;
  quotationId: number | null = null;
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: Date = new Date();
  userNameUpdate: string = '';
  action: string = "";
}